import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// Kept in sync with backend `ROBOBALL_FALLBACK_JERSEY` — used only if the
// query hasn't resolved yet.
export const ROBOBALL_FALLBACK_ASSET =
  "/assets/robo-ball/neutral_black_gold.png";

/**
 * Public, no-auth presentation-state hook. Backend deterministically picks
 * the jersey based on `ROBOBALL_ACTIVE_ISO_CODES` env; the frontend just
 * mirrors whatever the endpoint returns.
 *
 * 15-min stale + interval revalidation keeps the FAB tuned to changes
 * without polling aggressively.
 */
export function useRoboBallContext() {
  return useQuery({
    queryKey: ["robo-ball", "context"],
    queryFn: async () =>
      (await axios.get(`${API}/api/robo-ball/context`)).data,
    staleTime: 15 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchInterval: 15 * 60 * 1000,
    retry: 1,
  });
}

/**
 * Resolved absolute asset URL for the current Robo-Ball jersey. Falls back
 * to the neutral asset if the query hasn't resolved (or errors out).
 */
export function useRoboBallAssetUrl() {
  const { data } = useRoboBallContext();
  const path = data?.jersey_asset || ROBOBALL_FALLBACK_ASSET;
  if (typeof window === "undefined") return path;
  return `${window.location.origin}${path}`;
}
